/**
 * タイムアウト付き fetch。
 *
 * fetch は既定でタイムアウトを持たない。応答が返らない場合はブラウザ既定
 * (Chrome は約300秒) まで待ち続けるため、UI 側は「ボタンがスピナーのまま固まる」
 * = ユーザーには「開かない」ように見える。外部 API を叩く箇所では必ずこれを使う。
 *
 * 中断時は fetch が AbortError (DOMException) を throw するので、呼び出し側の
 * 既存 catch がそのまま拾える。
 */

/** 対話フロー (新規作成など、人が待っている処理) の既定タイムアウト。 */
export const INTERACTIVE_TIMEOUT_MS = 10_000;

export async function fetchWithTimeout(
  input: string | URL,
  timeoutMs: number = INTERACTIVE_TIMEOUT_MS,
  init?: RequestInit,
): Promise<Response> {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), timeoutMs);
  try {
    return await fetch(input, { ...init, signal: ctl.signal });
  } finally {
    clearTimeout(timer);
  }
}
